import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { DocumentsRoute } from "../../containers/DocumentsRoute";

export const Route = createFileRoute("/_layout-nosidebar/documents")({
    component: Documents,
});

function Documents() {
    const storedUserDatasources: string[] = JSON.parse(
        localStorage.getItem("userDatasources") ?? "[]",
    );
    const [selectedIndex, setSelectedIndex] = useState<string>(() => {
        return localStorage.getItem("selectedIndex") ?? storedUserDatasources[0] ?? "";
    });

    useEffect(() => {
        localStorage.setItem("selectedIndex", selectedIndex);
        setSelectedIndex(selectedIndex);
    }, [selectedIndex]);

    return <DocumentsRoute index={selectedIndex} setSelectedIndex={setSelectedIndex} />;
}
